import { render, staticRenderFns } from "./MyClaimsNotifications.vue?vue&type=template&id=6074b173&"
import script from "./MyClaimsNotifications.vue?vue&type=script&lang=js&"
export * from "./MyClaimsNotifications.vue?vue&type=script&lang=js&"
import style0 from "./MyClaimsNotifications.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports